import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Box,
  IconButton,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

interface ExportDialogProps {
  open: boolean
  onClose: () => void
  onComplete: () => void
}

const ExportDialog: React.FC<ExportDialogProps> = ({ open, onClose, onComplete }) => {
  const [formData, setFormData] = useState({
    dataType: 'leads',
    dateRange: '30d',
    format: 'csv',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false)
      onComplete()
    }, 1000)
  }

  const handleClose = () => {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Export Data
          <IconButton onClick={handleClose} disabled={isLoading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            select
            fullWidth
            name="dataType"
            label="Data Type"
            value={formData.dataType}
            onChange={handleChange}
            sx={{ mb: 3 }}
          >
            <MenuItem value="leads">Leads</MenuItem>
            <MenuItem value="conversations">Conversations</MenuItem>
            <MenuItem value="bookings">Bookings</MenuItem>
            <MenuItem value="analytics">Analytics Report</MenuItem>
          </TextField>
          
          <TextField
            select
            fullWidth
            name="dateRange"
            label="Date Range"
            value={formData.dateRange}
            onChange={handleChange}
            sx={{ mb: 3 }}
          >
            <MenuItem value="7d">Last 7 days</MenuItem>
            <MenuItem value="30d">Last 30 days</MenuItem>
            <MenuItem value="90d">Last 90 days</MenuItem>
            <MenuItem value="all">All time</MenuItem>
          </TextField>
          
          <TextField
            select
            fullWidth
            name="format"
            label="Format"
            value={formData.format}
            onChange={handleChange}
          >
            <MenuItem value="csv">CSV</MenuItem>
            <MenuItem value="xlsx">Excel</MenuItem>
            <MenuItem value="pdf">PDF Report</MenuItem>
          </TextField>
        </DialogContent>
        
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
          >
            {isLoading ? 'Preparing Export...' : 'Export Data'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default ExportDialog
